export default function(nga, admin) {
    let entity = admin.getEntity('competence')
        .label('COMPETENCES');

    entity.listView()
        .fields([
            nga.field('id').label('ID').isDetailLink(true).detailLinkRoute('show'),
            nga.field('name').label('NAME').isDetailLink(true).detailLinkRoute('show'),
            nga.field('description').label('DESCRIPTION').isDetailLink(true).detailLinkRoute('show'),
            /*nga.field('abilities')
                .label('ABILITIES')
                .template('<ma-filtered-list-button label="{{ value }}" entity-name="ability" ' +
                    'filter="{  competences: entry.values.id }" size="xs"></ma-filtered-list-button>')*/
        ])
        .sortDir('asc')
        .url('competences')
        /*.prepare(['Restangular', 'datastore', 'entries', 'Entry', function (Restangular, datastore, entries, Entry) {
            return Restangular
                .all('abilities')
                .getList()
                .then(function (data) {
                    data = data.data ? data.data : data;

                    entries.forEach(function (e, i) {
                        e.values.abilities = 0;

                        data.forEach(function (i, ii) {
                            if (i.competences && i.competences.indexOf(e.values.id) >= 0 )
                                e.values.abilities++;
                        });
                    })
                });
        }]);*/

    if(HasRole('admin')) {
        entity.showView().fields([
            nga.field('id').label('ID'),
            nga.field('name').label('NAME'),
            nga.field('description').label('DESCRIPTION'),
            /*
            nga.field('abilities', 'referenced_list').label('ABILITIES')
                .targetEntity(nga.entity('ability').url('abilities'))
                .targetReferenceField('competences')
                .targetFields([
                    nga.field('id').label('ID').isDetailLink(true),
                    nga.field('name').label('NAME').isDetailLink(true)
                        .map(function truncate(value, entry) {
                            return entry['name'];
                        })
                ])*/

        ]);

        entity.creationView().fields([
            nga.field('name').label('NAME'),
            nga.field('description').label('DESCRIPTION')
        ]);

        entity.editionView().fields(
            entity.creationView().fields()
        );
        entity.deletionView();
    }

    return entity;
}



/** WEBPACK FOOTER **
 ** ./js/entities/competence/config.js
 **/